/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */

import { fromJS } from 'immutable';

import {
  LOAD_REPOS_SUCCESS,
  LOAD_REPOS,
  LOAD_REPOS_ERROR,
  SET_WORKSPACE_THEME,
  SET_NOTIFICATION_BANNER_HEIGHT,
  TOGGLE_MOBILE_SIDEBAR,
  SET_AI_SUMMARY_PANEL,
  SET_REVIEWER_BANNER,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  loading: false,
  error: false,
  currentUser: false,
  userData: {
    repositories: false,
  },
  workspaceTheme: 'light',
  mobileSidebarOpen: false,
  notificationBannerHeight: 0,
  aiSummaryPanelOpen: false,
  showReviewerBanner: false,
  activityId: null,
});

function appReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REPOS:
      return state
        .set('loading', true)
        .set('error', false)
        .setIn(['userData', 'repositories'], false);
    case LOAD_REPOS_SUCCESS:
      return state
        .setIn(['userData', 'repositories'], action.repos)
        .set('loading', false)
        .set('currentUser', action.username);
    case LOAD_REPOS_ERROR:
      return state
        .set('error', action.error)
        .set('loading', false);
    case SET_WORKSPACE_THEME:
      localStorage.setItem('workspaceTheme', action.workspaceTheme);
      return state
        .set('workspaceTheme', action.workspaceTheme);
    case SET_NOTIFICATION_BANNER_HEIGHT:
      return state.set('notificationBannerHeight', action.height);
    case TOGGLE_MOBILE_SIDEBAR:
      return state.set('mobileSidebarOpen', action.visible !== undefined
        ? action.visible
        : !state.get('mobileSidebarOpen'));
    case SET_AI_SUMMARY_PANEL:
      return state
        .set('aiSummaryPanelOpen', action.aiSummaryPanelOpen)
        .set('activityId', action.activityId);
    case SET_REVIEWER_BANNER :
      return state.set('showReviewerBanner', action.flag);
    default:
      return state;
  }
}

export default appReducer;
